import { Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Schedule } from 'src/app/api/services/schedule';
import { ItemSelectorDialogComponent } from 'src/app/components/folders/item-selector-dialog/item-selector-dialog.component';
import { ScheduleSelectorService } from '../../services/schedule-selector.service';

@Component({
    selector: 'schedule-selector',
    templateUrl: './schedule-selector.component.html',
    styleUrls: ['./schedule-selector.component.scss'],
    standalone: false
})
export class ScheduleSelectorComponent {

  @ViewChild('tooltipTrigger') tooltipTrigger: ElementRef;
  @Input() additionalTooltipClass: string;

  filterConfig = {
    placeholder: 'Search schedules'
  };
  search: any = {
    sortBy: 'changeDate',
    reverse: true
  };

  private matDialog = inject(MatDialog);
  protected scheduleSelectorService = inject(ScheduleSelectorService);

  openDialog() {
    const dialogRef =this.matDialog.open(
      ItemSelectorDialogComponent<Schedule>,
      { 
        data: { kind: 'Schedule', multiple: true }, 
        ariaLabelledBy: 'title',
        ariaModal: true
      }
    );
    dialogRef.componentInstance.itemSelectorService = this.scheduleSelectorService;
    dialogRef.afterClosed().subscribe((result) => {
      if (result.action) {
        result.action === 'add'
          ? this.addSchedule()
          : this.editSchedule(result.item);
      } else if (result) {
        this.select();
      }
    });
  }

  select() {
    this.scheduleSelectorService.select();
  }

  addSchedule() {
    this.scheduleSelectorService.addSchedule();
  }

  editSchedule(schedule: any) {
    this.scheduleSelectorService.editSchedule(schedule);
  }

  filterSchedule(schedule: any): boolean {
    let query = this.scheduleSelectorService.search?.query;

    return !query || schedule?.name.toLowerCase().indexOf(query.toLowerCase()) !== -1;
  }
}
